import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { useMemo, useState, createContext } from 'react';

type CurrentLeftSplitContextType = {
    isLeftPanelOpened: boolean;
    setIsLeftPanelOpened: Dispatch<SetStateAction<boolean>>;
};
type CurrentHeaderContextType = {
    isHeaderOpened: boolean;
    setIsHeaderOpened: Dispatch<SetStateAction<boolean>>;
};

export const PageHeaderLayoutContext = createContext<CurrentHeaderContextType>({
    isHeaderOpened: true,
    setIsHeaderOpened: () => undefined,
});

export const PageLeftSplitLayoutContext = createContext<CurrentLeftSplitContextType>({
    isLeftPanelOpened: true,
    setIsLeftPanelOpened: () => undefined,
});

export const PageLayoutContextProvider = ({ children }: { children: ReactNode }) => {
    const [isLeftPanelOpened, setIsLeftPanelOpened] = useState(true);
    const [isHeaderOpened, setIsHeaderOpened] = useState(true);

    const headerContextValue = useMemo(
        () => ({
            isHeaderOpened,
            setIsHeaderOpened,
        }),
        [isHeaderOpened],
    );

    const splitContextValue = useMemo(
        () => ({
            isLeftPanelOpened,
            setIsLeftPanelOpened,
        }),
        [isLeftPanelOpened],
    );

    return (
        <PageHeaderLayoutContext.Provider value={headerContextValue}>
            <PageLeftSplitLayoutContext.Provider value={splitContextValue}>
                {children}
            </PageLeftSplitLayoutContext.Provider>
        </PageHeaderLayoutContext.Provider>
    );
};

PageLayoutContextProvider.displayName = 'PageLayoutContextProvider';
